/**
 * Serviços privativos (isCategoryPaxGroup): a API da Civitatis aceita apenas
 * UMA faixa de grupo por carrinho. Selecionar uma faixa zera as demais para
 * que o cliente não monte um carrinho que o fornecedor recusa.
 */
export const setPaxCount = (counts, categoryId, value, isGroup) => {
	const next = isGroup
		? Object.keys(counts || {}).reduce((acc, k) => ({ ...acc, [k]: 0 }), {})
		: { ...(counts || {}) };
	next[categoryId] = value;
	return next;
};

/** Faixas de grupo selecionadas (quantidade > 0). */
export const selectedGroupCount = (counts) =>
	Object.values(counts || {}).filter((v) => Number(v) > 0).length;

export default setPaxCount;
